import { OPPORTUNITIES_PAGE } from 'constants/pages'
import { createOpportunitiesPageTitleSelector } from 'selectors/oppertunitiesSelectors'
import { useMemo } from 'react'
import { useStoreSelector } from 'helpers/reactReduxHelpers'

export const usePageTitle = (page: typeof OPPORTUNITIES_PAGE) => {
  const pageTitleSelector = useMemo(() => createOpportunitiesPageTitleSelector(page), [page])
  return useStoreSelector(pageTitleSelector)
}
